import axios from 'axios';
import env from "react-dotenv";

var BASE_URL = undefined;
if (env.PRODUCTION_ENV === 'true') {
    BASE_URL = env.BASE_URL
} else {
    BASE_URL = 'http://localhost:8006'
}

export default axios.create({
    baseURL: BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});